export const FETCH_USERS_BASED_ON_ROLE_START =
  "FETCH_USERS_BASED_ON_ROLE_START";
export const FETCH_USERS_BASED_ON_ROLE_SUCCESS =
  "FETCH_USERS_BASED_ON_ROLE_SUCCESS";
export const FETCH_USERS_BASED_ON_ROLE_FAILURE =
  "FETCH_USERS_BASED_ON_ROLE_FAILURE";

export const ON_CHANGE_APPLY_TRADER_FILTER = "ON_CHANGE_APPLY_TRADER_FILTER";
export const ON_CHANGE_APPLY_TRADER_CLEAR_FILTER = "ON_CHANGE_APPLY_TRADER_CLEAR_FILTER"
